/**
 * AI Management Page
 * Standalone page for AI configuration and management
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import AIManagementTab from './AIManagementTab';

const AIManagementPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          AI Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configure and manage AI settings
        </Typography>
      </Box>
      <AIManagementTab />
    </Container>
  );
};

export default AIManagementPage;
